
import React from 'react';
import { FeatureShowcase } from '@/components/subscription/FeatureShowcase';

export function QuizPreview() {
  const benefits = [
    "Adaptive quizzes that adjust to your skill level",
    "Thousands of exam-specific practice questions",
    "Detailed explanations for each answer option",
    "Performance tracking with comprehensive analytics",
    "Create custom quizzes based on topics you need to practice",
    "Timed practice sessions to build exam stamina"
  ];
  
  const screenshots = [
    {
      url: "/lovable-uploads/7f46bbc1-4899-44bf-b641-c9ae0af6de27.png",
      caption: "Adaptive Learning - Questions that match your skill level"
    }
  ];

  return (
    <FeatureShowcase
      title="Adaptive Quiz System"
      description="Practice with personalized quizzes that adapt to your knowledge level and learning needs."
      featureName="Quiz"
      benefits={benefits}
      screenshots={screenshots}
    />
  );
}
